import "@nextgisweb/jsrealm/with-chunks!@nextgisweb/jsrealm/locale/en"
ngwConfig.plurals = [2, n => Number((n != 1))];
export { default as antd } from "/opt/ngw/node_modules/antd/es/locale/en_US.js";
import dayjs from "@nextgisweb/gui/dayjs";
import "/opt/ngw/node_modules/dayjs/locale/en.js";
dayjs.locale('en');